module.exports = __webpack_public_path__ + "img/marketa_logos-05.cb076bc8.png";